import { create } from 'zustand'

export const useTutorialStore = create((set) => ({
  showTutorialModal: null,
  hideTutorial: () => set({ showTutorialModal: null }),
  showTutorial: (tutorialId) => set({ showTutorialModal: tutorialId }),
}))

export const TutorialEnum = Object.freeze({
  Basics: 'training-1',
  Dash: 'training-2',
  Combos: 'training-3',
  CombosAdvanced: 'training-4',
  RangeWeapon: 'training-5',
});